module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.create) ? _c('imageable-control', {
    attrs: {
      "imageable-id": _vm.form.id,
      "imageable-type": "Product"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "is-pulled-right"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Save Changes")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "checkbox",
      "label": "<strong>Activate Product</strong>",
      "id": "listed",
      "error": _vm.form.errors.get('listed')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.listed),
      callback: function($$v) {
        _vm.$set(_vm.form, "listed", $$v)
      },
      expression: "form.listed"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "select",
      "id": "company",
      "label": "Show On Company Website</small>",
      "error": _vm.form.errors.get('company'),
      "option_name": 'name',
      "option_value": 'value',
      "options": [{
          name: 'All Companies',
          value: ''
        },
        {
          name: 'Crockett',
          value: 'CF'
        },
        {
          name: 'Bells',
          value: 'BELLS'
        } ]
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.company),
      callback: function($$v) {
        _vm.$set(_vm.form, "company", $$v)
      },
      expression: "form.company"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Full Product Name",
      "id": "name",
      "error": _vm.form.errors.get('name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "SKU",
      "id": "sku",
      "error": _vm.form.errors.get('sku')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.sku),
      callback: function($$v) {
        _vm.$set(_vm.form, "sku", $$v)
      },
      expression: "form.sku"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-9"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Short Product Name",
      "id": "short_name",
      "error": _vm.form.errors.get('short_name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.short_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "short_name", $$v)
      },
      expression: "form.short_name"
    }
  })], 1)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "textarea",
      "label": "Description",
      "id": "description",
      "error": _vm.form.errors.get('description')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Price",
      "id": "price",
      "error": _vm.form.errors.get('price')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.$set(_vm.form, "price", $$v)
      },
      expression: "form.price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Shipping Cost <small>(blank for override)</small>",
      "id": "shipping",
      "error": _vm.form.errors.get('shipping')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.shipping),
      callback: function($$v) {
        _vm.$set(_vm.form, "shipping", $$v)
      },
      expression: "form.shipping"
    }
  }), _vm._v(" "), (_vm.productParts.length > 0) ? _c('label', {
    staticClass: "label text-danger"
  }, [_vm._v("\n        Shipping cost will be overridden by subproducts\n      ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('form-group', {
    attrs: {
      "type": "select",
      "label": "Recurring Shipments <small>(months)</small>",
      "id": "months",
      "error": _vm.form.errors.get('months'),
      "option_name": 'name',
      "option_value": 'value',
      "options": [{
          name: 'None (Single Shipment)',
          value: ''
        },
        {
          name: '2 Shipments',
          value: 2
        },
        {
          name: '3 Shipments',
          value: 3
        },
        {
          name: '4 Shipments',
          value: 4
        },
        {
          name: '5 Shipments',
          value: 5
        },
        {
          name: '6 Shipments',
          value: 6
        },
        {
          name: '7 Shipments',
          value: 7
        },
        {
          name: '8 Shipments',
          value: 8
        },
        {
          name: '9 Shipments',
          value: 9
        },
        {
          name: '10 Shipments',
          value: 10
        },
        {
          name: '11 Shipments',
          value: 11
        },
        {
          name: '12 Shipments',
          value: 12
        } ]
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.months),
      callback: function($$v) {
        _vm.$set(_vm.form, "months", $$v)
      },
      expression: "form.months"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Weight <small>(approximate in Lbs.)</small>",
      "id": "weight",
      "error": _vm.form.errors.get('weight')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.weight),
      callback: function($$v) {
        _vm.$set(_vm.form, "weight", $$v)
      },
      expression: "form.weight"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n      Orders Allowed Between\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "control"
  }, [_c('slider-control', {
    attrs: {
      "min": _vm.currentSeason.start.getTime(),
      "max": _vm.currentSeason.end.getTime(),
      "start": _vm.getOrderStartDate(),
      "end": _vm.getOrderEndDate(),
      "step": 24 * 60 * 60 * 1000,
      "update-display": _vm.formatDate
    },
    on: {
      "start": _vm.setOrderStart,
      "end": _vm.setOrderEnd
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Available Shipping Months")]), _vm._v(" "), _c('span', {
    staticClass: "control"
  }, [_c('product-month-selector', {
    attrs: {
      "starting-months": _vm.form.ship_months
    },
    on: {
      "monthsChanged": function($event) {
        _vm.form.ship_months = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.form.ship_months.length < _vm.form.months) ? _c('label', {
    staticClass: "label text-danger"
  }, [_vm._v("\n      You need to select more months or this product cannot be ordered!\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [(!_vm.editSlug) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.startSlugEdit()
      }
    }
  }, [_vm._v("Edit Product URL")]) : _c('a', {
    on: {
      "click": function($event) {
        return _vm.cancelSlugEdit()
      }
    }
  }, [_vm._v("Cancel editing URL")])]), _vm._v(" "), (_vm.editSlug) ? _c('form-group', {
    attrs: {
      "type": "text",
      "label": '<small>crockettfarms.com/products/' + _vm.form.slug + '</small>',
      "id": "slug",
      "error": _vm.form.errors.get('slug')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.slug),
      callback: function($$v) {
        _vm.$set(_vm.form, "slug", $$v)
      },
      expression: "form.slug"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [(!_vm.editOrderDescription) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.startOrderDescriptionEdit()
      }
    }
  }, [_vm._v("Add Special Order Information")]) : _c('a', {
    on: {
      "click": function($event) {
        return _vm.cancelOrderDescriptionEdit()
      }
    }
  }, [_vm._v("Remove Special Order Information")])]), _vm._v(" "), (_vm.editOrderDescription) ? _c('form-group', {
    attrs: {
      "type": "textarea",
      "label": "Order Information <small>(use for important information (look at SHC for example))</small>",
      "id": "ordering_description",
      "error": _vm.form.errors.get('ordering_description')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.ordering_description),
      callback: function($$v) {
        _vm.$set(_vm.form, "ordering_description", $$v)
      },
      expression: "form.ordering_description"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  }, [_c('div', {
    staticClass: "is-pulled-right"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Save Changes")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('em', [_vm._v("(if shipping ends before the order end date, product cannot be ordered)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-297d711c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/forms/ProductForm.vue
// module id = 516
// module chunks = 0